import type { PlacementState } from 'app/modules/wallforming/components/state-management/placement/types';
import type { StoreApi } from 'zustand';

/** State slices whose identity change means the user-visible workspace (and thus any in-flight solver request) changed. */
const workspaceSlices = [
    'pois',
    'articleGroups',
    'articleInstanceSelections',
    'poiSelection',
    'isViewMode',
    'inputBindings',
    'automatedPlacementSettingsByType',
    'selectedSettingType',
    'selectedSettingView'
] as const satisfies ReadonlyArray<keyof PlacementState>;

const hasInstances = (instances?: object) => Object.keys(instances ?? {}).length > 0;

const placementsChanged = (next: PlacementState, previous: PlacementState) =>
    next.articles !== previous.articles &&
    [...new Set([...Object.keys(next.articles), ...Object.keys(previous.articles)])].some((id) => {
        const current = next.articles[id]?.articleInstances;
        const former = previous.articles[id]?.articleInstances;
        return current !== former && (hasInstances(current) || hasInstances(former));
    });

/** Bumps `workspaceRevision` on every meaningful workspace change so stale async results can be discarded. */
export const trackWorkspaceRevision = (
    api: StoreApi<PlacementState>,
    set: (partial: Partial<PlacementState>) => void
) =>
    api.subscribe((next, previous) => {
        if (placementsChanged(next, previous) || workspaceSlices.some((key) => next[key] !== previous[key])) {
            set({ workspaceRevision: next.workspaceRevision + 1 });
        }
    });
